import React, {useState} from 'react'
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import {motion} from 'framer-motion';

import {images} from '../../constants';
import './Navbar.scss';

function Navbar() {
    const [toggle, setToggle] = useState(false);



  return (
    <nav className="app__navbar">
        <div className='app__navbar-logo'>
            <img src={images.logo} alt="logo"/>
            <span class="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">H O B H I T  S I N H A</span>
        </div>
        <ul className='app__navbar-links'> 
            {['home','about','work','skills','contact'].map((item) => (
                <li className= 'app__flex p-text' key={`link-${item}`}>
                    <div/>
                    <a href={`#${item}`}>{item}</a>
                </li>
            ))}
            <li className='app__flex p-text' key={`link-resume`}>
            <div />
            <a href="https://drive.google.com/file/d/1ZboQQD9iALFTXNZhUcgn_Bfav1iZi5KP/view" target="_blank" rel="noopener noreferrer">Resume</a>
          </li>
        </ul>
        <div className='app__navbar-menu'>
            <HiMenuAlt4 onClick= {() => setToggle(true)}/>
            { //if toggle true meaning someone open mobile view 
                toggle && (
                    //this is how we use framer motion motion.elementwewanttoise 
                <motion.div 
                    whileInView={{ x: [300, 0] }}
                    transition={{ duration: 0.85, ease: 'easeOut' }}
                >
                    <HiX onClick={() => setToggle(false)} />
                    <ul>
                    {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
                        <li key={item}>
                        <a href={`#${item}`} onClick={() => setToggle(false)}>
                            {item}
                        </a>
                        </li>
                    ))}
                    </ul>
                </motion.div>
                )
            }
        </div>
    </nav>
  )
}

export default Navbar